"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = DatePicker;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_day_picker_1 = require("react-day-picker");
const Day_1 = require("./Day");
const Header_1 = require("./Header");
const WeekHeader_1 = require("./WeekHeader");
const Css_1 = require("../../../Css");
const utils_1 = require("../../../utils");
require("./DatePicker.css");
function DatePicker(props) {
    const { value, onSelect, disabledDays, dottedDays, useYearPicker } = props;
    const tid = (0, utils_1.useTestIds)(props, "datePicker");
    return ((0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.dib.bgWhite.xs.$, ...tid, children: (0, jsx_runtime_1.jsx)(react_day_picker_1.DayPicker, { components: { Caption: useYearPicker ? Header_1.YearSkipHeader : Header_1.Header, Head: WeekHeader_1.WeekHeader, Day: Day_1.Day }, 
            // DatePicker only allows for a single date to be `selected` (per our props) though DayPicker expects an array of dates
            selected: value ? [value] : [], defaultMonth: value !== null && value !== void 0 ? value : new Date(), onDayClick: (day, modifiers) => {
                if (modifiers.disabled)
                    return;
                // Set the day value
                onSelect(day);
            }, disabled: disabledDays, modifiers: { indicatorDot: dottedDays !== null && dottedDays !== void 0 ? dottedDays : [] } }) }));
}
